import React, { Component } from "react";
import { Table, Button, Form } from "react-bootstrap";
import axios from "axios";

const API_URL = "https://madhusewingmachines.com/api/products";

const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");
    return { headers: { Authorization: `Bearer ${token}` } };
};

export default class TrendingProducts extends Component {
    state = {
        products: [],
        editingProductId: null,
        editedProduct: {},
    };

    componentDidMount() {
        this.fetchProducts();
    }

    fetchProducts = async () => {
        try {
            const response = await axios.get(API_URL, getAuthHeaders());
            this.setState({ products: response.data });
        } catch (error) {
            console.error("Error fetching products:", error.response?.data || error);
        }
    };

    handleAddProduct = async () => {
        const newProduct = {
            name: "New Sewing Machine",
            price: 0,
            description: "Description here...",
        };
        try {
            const response = await axios.post(API_URL, newProduct, getAuthHeaders());
            this.setState({ products: [...this.state.products, response.data] });
        } catch (error) {
            console.error("Error adding product:", error.response?.data || error);
        }
    };

    handleSaveProduct = async () => {
        try {
            await axios.put(`${API_URL}/${this.state.editingProductId}`, this.state.editedProduct, getAuthHeaders());
            this.fetchProducts(); // Refresh the list
            this.setState({ editingProductId: null, editedProduct: {} });
        } catch (error) {
            console.error("Error updating product:", error.response?.data || error);
        }
    };

    handleDeleteProduct = async (id) => {
        try {
            await axios.delete(`${API_URL}/${id}`, getAuthHeaders());
            this.setState({ products: this.state.products.filter((product) => product.id !== id) });
        } catch (error) {
            console.error("Error deleting product:", error.response?.data || error);
        }
    };

    handleEditProduct = (product) => {
        this.setState({ editingProductId: product.id, editedProduct: { ...product } });
    };

    handleInputChange = (e, field) => {
        this.setState({
            editedProduct: { ...this.state.editedProduct, [field]: e.target.value },
        });
    };

    render() {
        return (
            <div className="p-4">
                <h2 className="mb-4">Trending Sewing Machines</h2>
                <Button onClick={this.handleAddProduct} variant="primary" className="mb-3">
                    Add Sewing Machine
                </Button>
                <Table bordered responsive>
                    <thead className="bg-light">
                        <tr>
                            <th>Images</th>
                            <th>Sewing Machine</th>
                            <th>Price ($)</th>
                            <th>Description</th>
                            <th>Actions</th>

                        </tr>
                    </thead>
                    <tbody>
                        {this.state.products.map((product) => (
                            <tr key={product.id} className="text-center">
                                {this.state.editingProductId === product.id ? (
                                    <>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                value={this.state.editedProduct.name}
                                                onChange={(e) => this.handleInputChange(e, "name")}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                value={this.state.editedProduct.price}
                                                onChange={(e) => this.handleInputChange(e, "price")}
                                                style={{ width: "80px" }}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                value={this.state.editedProduct.description}
                                                onChange={(e) => this.handleInputChange(e, "description")}
                                            />
                                        </td>
                                        <td>
                                            <Button onClick={this.handleSaveProduct} variant="success" className="me-2">
                                                Save
                                            </Button>
                                        </td>
                                    </>
                                ) : (
                                    <>
                                        {/* <td>{<productSchemaz}</td> */}
                                        <td>{product.name}</td>
                                        <td>${product.price}</td>
                                        <td>{product.description}</td>
                                        <td>
                                            <Button
                                                onClick={() => this.handleEditProduct(product)}
                                                variant="warning"
                                                className="me-2"
                                            >
                                                Edit
                                            </Button>
                                            <Button onClick={() => this.handleDeleteProduct(product.id)} variant="danger">
                                                Delete
                                            </Button>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    }
}
